export function weekdayLabel(day, t) {
    const key = String(day || '').trim().toLowerCase();
    if (!key) return '';
    return t(`weekdays.${key}`, {
        defaultValue: key.charAt(0).toUpperCase() + key.slice(1),
    });
}

export function formatShiftRange(openTime, closeTime) {
    return `${formatClock(openTime)}–${formatClock(closeTime)}`;
}

function formatClock(value) {
    const match = /^(\d{1,2}):(\d{2})$/.exec(String(value || '').trim());
    if (!match) return value;
    return `${match[1].padStart(2, '0')}:${match[2]}`;
}
